import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

export const asyncRoutes = [
  { path: '/dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '仪表盘', icon: 'el-icon-s-home' } },
  { path: '/goods/list', component: () => import('@/views/goods/list.vue'), meta: { title: '商品列表', icon: 'el-icon-goods' } },
  { path: '/goods/edit', component: () => import('@/views/goods/edit.vue'), meta: { title: '新增商品', hidden: true } },
  { path: '/goods/edit/:id', component: () => import('@/views/goods/edit.vue'), meta: { title: '编辑商品', hidden: true } },
  { path: '/category/list', component: () => import('@/views/category/list.vue'), meta: { title: '分类管理', icon: 'el-icon-menu' } },
  { path: '/freight/list', component: () => import('@/views/freight/list.vue'), meta: { title: '运费设置', icon: 'el-icon-coin' } },
  { path: '/banner/list', component: () => import('@/views/banner/list.vue'), meta: { title: '首页轮播', icon: 'el-icon-picture-outline' } },
  { path: '/order/list', component: () => import('@/views/order/list.vue'), meta: { title: '订单管理', icon: 'el-icon-tickets' } },
  { path: '/order/detail/:id', component: () => import('@/views/order/detail.vue'), meta: { title: '订单详情', hidden: true } }
]

const routes = [
  { path: '/login', component: () => import('@/views/login/index.vue') },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    redirect: '/dashboard',
    children: asyncRoutes
  }
]

const router = new VueRouter({
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  const hasToken = getToken()
  if (to.path === '/login') {
    next()
  } else if (!hasToken) {
    next('/login')
  } else {
    next()
  }
})

export default router
